import Sider from './Sider';
import './Sider.scss';

export default Sider;
